import { Component } from '@angular/core';
import { ProgressSpinnerMode, ThemePalette } from '@angular/material';
import { LoaderService } from '../../services/loader.service';
import { Subject } from 'rxjs/Subject';

@Component({
  selector: 'app-progress-spinner',
  templateUrl: './progress-spinner.component.html',
  styleUrls: ['./progress-spinner.component.scss']
})
export class ProgressSpinnerComponent {

  color: ThemePalette;
  mode: ProgressSpinnerMode;
  value: number;
  isInProgress: Subject<boolean> = this.loaderService.isInProgress;

  constructor(private loaderService: LoaderService) {
    this.color = 'warn';
    this.mode = 'indeterminate';
    this.value = 50;
  }
}



// WEBPACK FOOTER //
// /Users/ugyen/Documents/Bhutan-office/my_bhutan/mybhutan-travel/src-admin/app/shared/progress-spinner/progress-spinner.component.ts